export default "assets/images/player-23136ca6.png";